import type {
  ClientLoaderFunctionArgs,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadDealDetailRoute } from '@jane/bloom/loaders/routes/dealDetail.server';
import { dealDetailRouteMeta } from '@jane/bloom/resources/meta/routes/dealDetail';
import type { RouteHandle } from '@jane/bloom/types/routeHandle';

export const handle: RouteHandle = {
  hydrate: true,
};

export const meta: MetaFunction<typeof loader> = (args) => {
  return dealDetailRouteMeta(args);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  loadDealDetailRoute({ args, shouldPinStore: true });

export { DealDetailRouteComponent as default } from '@jane/bloom/components/routes/dealDetail/dealDetailComponent';
